import { ChangeDetectorRef, Component, signal } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { LoaderService } from '../../../core/services';
import { ForceAny } from '../../typescript';

@Component({
  selector: 'app-spinner',
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {
  showTimeoutMessage = false;
  loaderMessage = signal<string>('');
  loaderTimeout: ForceAny;
  loading = false;

  $subscription = new Subscription();
  private destroy$ = new Subject<void>();
  constructor(
    public loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.listenLoaderObserver();

    this.$subscription.add(
      this.loaderService.loaderMessage.subscribe((message) => {
        this.loaderMessage.set(message);
      }),
    );
  }

  listenLoaderObserver() {
    this.$subscription.add(
      this.loaderService.isSectionWiseLoaderVisible.subscribe((res) => {
        this.loading = res;
        if (this.loaderTimeout) {
          clearTimeout(this.loaderTimeout);
        }
        if (res) {
          this.loaderTimeout = setTimeout(() => {
            if (this.loading) {
              this.showTimeoutMessage = true;
            }
          }, 30000); // 30 seconds
        } else {
          // If loading is false, reset the timeout message
          this.showTimeoutMessage = false;
        }

        this.cdr.detectChanges();
      }),
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.$subscription.unsubscribe();
  }
}
